<template>
  <main class="block-main main" :class="device_platform">
    <img src="../images/bg/banner_main_m.jpg" alt="Баннер" class="main__img" />
    <div class="main__content">
      <div class="container">
        <div class="main__content-inner">
          <h2 class="main__title">
            <template v-if="time_to_change">
              Корпоративный парк Audi в Ауди Центре Север
              <br />Финальные условия на ограниченную партию
              <!-- Специальные преимущества на Audi
							<br>Только три дня -->
            </template>
            <template v-else>
              Ночь продаж Audi в Ауди Центре Север только с 25 по 26 октября
              <br />Финальные условия на ограниченную партию
            </template>
          </h2>
          <!-- <p class="main__subtitle">
						Выберите свой подарок
						<br>Бонус за трейд-ин до 350 000 ₽
						<br>Кредит от 1%
					</p> -->
        </div>
        <div class="main__form">
          <callback-input
            :data="{ type: 'sale', form: 'cars' }"
            :form_class="''"
            button_theme="button_theme_bordered_black"
            v-on="$listeners"
          >
            Получить предложение
          </callback-input>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Mixin from "../common/mixin";
import finance from "../common/finance";
import CallbackInput from "./callback-form/callback-input";

export default {
  name: "block-main",
  components: { CallbackInput },
  mixins: [Mixin, finance],
  data() {
    return {};
  },
  computed: {
    time_to_change() {
      const changer = new Date(2022, 9, 26);
      const today = new Date();
      if (today >= changer) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getAgreement() {
      this.$emit("getAgreement");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.main {
  margin-top: 65px;
  padding-top: 20px;
  background-image: url("../images/bg/banner_main.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
  height: calc(100vw * 900 / 1920);
  color: #000;

  &__content {
    height: 100%;
    display: flex;
    align-items: flex-end;
    padding-left: 6.3%;
    padding-bottom: 9%;

    @media (max-width: 1440px) {
      padding-bottom: 5%;
    }

    &-inner {
      padding: 7px;
      display: inline-flex;
      flex-direction: column;
      margin-bottom: 20px;
      display: none;
    }

    .container {
      max-width: none;
    }
  }

  &__title {
    font-family: "AudiTypeExt", sans-serif;
    font-size: calcFontSize(16, 30, 320, 1920);
    color: #fff;
  }

  &__subtitle {
    font-family: "AudiTypeExt", sans-serif;
    font-size: calcFontSize(14, 26, 320, 1920);
    margin-top: 10px;
    color: #fff;
  }

  &__form {
    max-width: 250px;
  }

  &__img {
    display: none;
  }
}

@media (max-width: 640px) {
  .main {
    margin-top: 136px;
    background-image: none;
    padding-top: 0;
    height: auto;
    color: #fff;
    &__content {
      padding: 20px 0;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      .container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    &__content-inner {
      padding: 0;
    }

    &__subtitle {
      margin: 30px 0 40px 0;
    }

    &__img {
      display: block;
      max-width: 100%;
    }

    &__form {
      max-width: 100%;
    }
  }
}
</style>
